$<HTMLAnchorElement>('.new-scaling-layout .read a').on('click', function(e) {
    const a = this;
    const {href} = a;
    if(!href.startsWith('mailto:'))
        return;
    e.preventDefault();
    const [oldPrice, newPrice] =
        (a.textContent ?? '')
            .trim()
            .split(' ')
            .filter(s => s.match(/\d/))
            .slice(-2);
    const words = [];
    for(const word of $(a).closest('p').children().toArray().map(el => el.textContent?.trim() ?? '')) {
        if(word.includes('%'))
            continue;
        if(word === '')
            break;
        words.push(word);
    }
    const product = words.join(" ");

    let subject = $('.new-scaling-layout [name="inquiry-subject"]').val() as string,
        body = $('.new-scaling-layout [name="inquiry-body"]').val() as string;
    const $multiSizeOffer = $(this).closest('.multiple-sizes-offer');
    if($multiSizeOffer[0]) {
        if ($multiSizeOffer.hasClass('alu-wall-shelf')) {
            body = $('.new-scaling-layout [name="alu-wall-shelf_inquiry_body"]').val() as string;
        } else if ($multiSizeOffer.hasClass('curtain-rail_white')) {
            body = $('.new-scaling-layout [name="curtain-rail_white_inquiry_body"]').val() as string;
        } else if ($multiSizeOffer.hasClass('curtain-rail_black')) {
            body = $('.new-scaling-layout [name="curtain-rail_black_inquiry_body"]').val() as string;
        } else if ($multiSizeOffer.hasClass('curtain-rail_steel')) {
            body = $('.new-scaling-layout [name="curtain-rail_steel_inquiry_body"]').val() as string;
        }
    } else {
        body = body
            .replaceAll('%{PRODUCT}', product)
            .replaceAll('%{OLD_PRICE}', oldPrice)
            .replaceAll('%{NEW_PRICE}', newPrice);
    }

    location.href = `${href}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
});
